import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ApplicantProfileTabs from "../../ApplicantProfile/ApplicantProfileTabs";
import { Getrequest } from "../../../../../context/AxiosRequest";
import { ContextData } from "../../../../../context/Context";

const drawerWidth = 270;

export default function Undergraduate() {


     const [GetToken,setGetToken] = React.useState()
     const [ChangeLoader,setChangeLoader] = React.useState()
     const {accesstoken} = React.useContext(ContextData)
     const [ApplicantData,setApplicantData] = React.useState(null)

    const GetApplicant = (user_token)=>{

      setGetToken(user_token)

    }

    React.useEffect(()=>{

                  async function FetchData() {
                       const response = await Getrequest(`auth/get_applicantBio_for_qualification_type/undergraduate/selection`,accesstoken)
                        setApplicantData(response)
                  }
  
                  FetchData()
    },[])


  return (
    <Box sx={{ display: "flex", zIndex: "1" }}>
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: {
            width: drawerWidth,
            boxSizing: "border-box",
          },
        }} 
      >
        <Toolbar />
        <Box sx={{ overflow: "auto" }}>
          <List>
           
            {ApplicantData !== null && ApplicantData.map((text, index) => (
              <ListItem className={`${text.user_token === GetToken && "bg-blue-700 text-white"}`} onClick={()=> GetApplicant(text.user_token)} key={index} disablePadding>
                <ListItemButton>
                  <span className="mr-1">{index + 1}.</span>
                  <ListItemIcon sx={{minWidth:"3px"}}>
                    {/* {index % 2 === 0 ? <InboxIcon /> : <MailIcon />} */}
                    <AccountCircleIcon />
                  </ListItemIcon>
                  <ListItemText  primary={`${text.fname} ${text.lname}`} />
                </ListItemButton>
              </ListItem>
            ))}
          </List> 
        </Box>
      </Drawer>

      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <ApplicantProfileTabs usertoken={GetToken} from="undergraduate" />
      </Box>
    </Box>
  );
}
